// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1oVwD","footer":"ModalError_footer__2FY9B"};